import React from 'react';
import Services from '../components/Services/Services';
import './PageStyles.css';

const ServicesPage: React.FC = () => {
  return (
    <div className="page-wrapper">
      <Services />
    </div>
  );
};

export default ServicesPage;
